module.exports = __webpack_public_path__ + "static/img/2bg_24.5c3adcc.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_24.png
// module id = 671
// module chunks = 1